var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isDisplaying)?_c('div',{attrs:{"id":"app"}},[_c('main-nav',{on:{"reload":_vm.reload}}),(!_vm.isLoading)?_c('router-view',{staticClass:"mainContent"}):_c('div',{key:"mainLanding",staticClass:"app-loading animate__animated animate__fadeIn"},[_c('ui-spinner')],1),_c('main-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }